export default "__VITE_ASSET__Ce2JVl9M__"